import { DataGrid } from "@mui/x-data-grid";
import { DASHBOARD_COLORS as C } from "./DashboardCard";
import { dataGridSx, withMinWidth } from "../utils/responsive";

export const STATUS_TABS = ["all", "pending", "approved", "rejected"];
export const EMPTY_FILTERS = { category: "", school: "", policeStation: "" };
const SEARCH_FIELDS = ["contact_person", "mobile1", "register_no", "email", "dl_no"];

const sameValue = (a, b) => String(a ?? "") === String(b ?? "");

// Search text, status tab and filter-panel values combined; the table and the phone cards both list this result.
export const filterDrivers = (drivers = [], { search = "", tab = "all", filters = EMPTY_FILTERS } = {}) => {
  const query = search.trim().toLowerCase();
  return drivers.filter((driver) => {
    const matchesSearch =
      !query || SEARCH_FIELDS.some((key) => String(driver[key] ?? "").toLowerCase().includes(query));
    const matchesTab = tab === "all" || driver.police_station_level1_status?.toLowerCase() === tab;
    const matchesCategory = !filters.category || driver.firm_types === filters.category;
    const matchesSchool = !filters.school || sameValue(driver.school_id, filters.school);
    const matchesPolice = !filters.policeStation || sameValue(driver.police_station_id, filters.policeStation);
    return matchesSearch && matchesTab && matchesCategory && matchesSchool && matchesPolice;
  });
};

// Shared by the MIS Reports table so every list grid looks the same.
export const gridSx = {
  ...dataGridSx,
  border: "none",
  borderRadius: 0,
  minHeight: 360,
  color: "#334155",
  fontSize: 13.5,
  "--DataGrid-containerBackground": "#F8FAFC",
  "--DataGrid-rowBorderColor": "#EEF2F6",
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
    fontSize: 12,
    color: C.muted,
    textTransform: "uppercase",
    letterSpacing: ".04em",
  },
  "& .MuiDataGrid-cell": { display: "flex", alignItems: "center" },
  "& .MuiDataGrid-row:hover": { bgcolor: "#F8FAFC" },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within": {
    outline: "none",
  },
};

export const FilterList = ({ rows = [], columns, loading, paginationModel, onPaginationModelChange, emptyOverlay, emptyOverlayProps }) => (
  <DataGrid
    rows={rows}
    getRowId={(row) => row.driver_id}
    columns={withMinWidth(columns)}
    loading={loading}
    rowHeight={52}
    columnHeaderHeight={44}
    pagination
    paginationModel={paginationModel}
    onPaginationModelChange={onPaginationModelChange}
    pageSizeOptions={[10, 20, 50]}
    slots={{ noRowsOverlay: emptyOverlay, noResultsOverlay: emptyOverlay }}
    slotProps={{
      noRowsOverlay: emptyOverlayProps,
      noResultsOverlay: emptyOverlayProps,
      loadingOverlay: { variant: "skeleton", noRowsVariant: "skeleton" },
    }}
    aria-label="Driver and conductor records"
    sx={gridSx}
    disableRowSelectionOnClick
  />
);
